import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RetailerFooter } from "@faire/retailer-visitor-shared/components/Footer/RetailerFooter";
import { PageInitialized } from "@faire/retailer-visitor-shared/events";
import { useMaybeAssignCategoryTreeExperiment } from "@faire/retailer-visitor-shared/lib/useMaybeAssignCategoryTreeExperiment";
import { useRecordMilestoneOnce } from "@faire/retailer-visitor-shared/stores/domain/useMilestone";
import { useIsCategoryPageLoading } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/useIsCategoryPageLoading";
import { LoggedInCategoryPageContent } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/MainContent/LoggedInCategoryPageContent";
import { useCategoryPageActionName } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useCategoryPageActionName";
import { useLoggedInCategoryPageUPLT } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useLoggedInCategoryPageUPLT";
import { useRecordCategoryPageImpression } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/useRecordCategoryPageImpression";
import { useCurrentCategoryModel } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useCurrentCategoryModel";
import { Z_INDICES } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/LoggedInCategoryPageStyles";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { WhenVisibilityIsImminent } from "@faire/web--source/ui/VisibilitySensor/WhenVisibilityIsImminent";
import { trackRetailersPageViewView } from "@faire/web-api--source/events/retailers/view/pageView";
import { IRecordCategoryNodesVisibilityRequest } from "@faire/web-api--source/indigofair/category/IRecordCategoryNodesVisibilityRequest";
import { HAS_VISITED_CATEGORY_SEARCH_PAGES } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/HAS_VISITED_CATEGORY_SEARCH_PAGES";
import * as React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
var Source = IRecordCategoryNodesVisibilityRequest.Source;
export var LoggedInCategoryPageBase = function() {
    var isLoading = useIsCategoryPageLoading();
    var recordMilestoneOnce = useRecordMilestoneOnce();
    var categoryModel = useCurrentCategoryModel();
    var viewport = useViewport();
    var loadTimingRef = useLoggedInCategoryPageUPLT();
    var maybeAssignCategoryTreeExperiment = useMaybeAssignCategoryTreeExperiment();
    useRecordCategoryPageImpression();
    useEffect(function() {
        recordMilestoneOnce(HAS_VISITED_CATEGORY_SEARCH_PAGES);
    }, [
        recordMilestoneOnce
    ]);
    useEffect(function() {
        maybeAssignCategoryTreeExperiment(function() {
            return [
                categoryModel.mostSpecificPathIdentifier
            ];
        }, viewport.isMobile ? Source.WEB_MOBILE_BREADCRUMB : Source.WEB_DESKTOP_BREADCRUMB);
    }, [
        viewport.isMobile,
        categoryModel.mostSpecificPathIdentifier,
        maybeAssignCategoryTreeExperiment
    ]);
    useEffect(function() {
        if (!isLoading) {
            PageInitialized.publish();
        }
    }, [
        isLoading
    ]);
    var pathname = useLocation().pathname;
    var pageType = pathname.includes("/suppliers") ? "suppliers" : "category";
    var pageName = useCategoryPageActionName();
    var _categoryModel_urlIdStrings = _sliced_to_array(categoryModel.urlIdStrings, 3), c1 = _categoryModel_urlIdStrings[0], c2 = _categoryModel_urlIdStrings[1], c3 = _categoryModel_urlIdStrings[2];
    useEffect(function() {
        trackRetailersPageViewView("", "", "", pageType, pathname, pageName, c1 !== null && c1 !== void 0 ? c1 : "", c2 !== null && c2 !== void 0 ? c2 : "", c3 !== null && c3 !== void 0 ? c3 : "");
    }, [
        pageType,
        pathname,
        pageName,
        c1,
        c2,
        c3
    ]);
    return /*#__PURE__*/ _jsxs(RootContainer, {
        children: [
            /*#__PURE__*/ _jsx(StyledMainContent, {
                pageLoadTimingRef: loadTimingRef
            }),
            /*#__PURE__*/ _jsx(WhenVisibilityIsImminent, {
                customizePlaceholder: /*#__PURE__*/ _jsx(RetailerFooterPlaceholder, {}),
                children: /*#__PURE__*/ _jsx(BlockInheritRow, {
                    children: /*#__PURE__*/ _jsx(StyledRetailerFooter, {
                        hideReferral: true
                    })
                })
            })
        ]
    });
};
var StyledMainContent = styled(LoggedInCategoryPageContent).withConfig({
    componentId: "sc-6b934112-0"
})([
    "",
    "{padding:0px;}"
], responsiveMediaQueries.desktopAndAbove);
// eslint-disable-next-line @faire/prefer-slate-attrs -- display: block is incompatible with Flex
var BlockInheritRow = styled(Row).attrs({
    align: "flex-start"
}).withConfig({
    componentId: "sc-6b934112-1"
})([
    "&&&{display:block;}position:inherit;width:100%;"
]);
var StyledRetailerFooter = styled(RetailerFooter).withConfig({
    componentId: "sc-6b934112-2"
})([
    "",
    "{background-color:white;position:relative;z-index:",
    ";}"
], responsiveMediaQueries.desktopAndAbove, Z_INDICES.footer.desktopAndAbove);
var RetailerFooterPlaceholder = styled.div.withConfig({
    componentId: "sc-6b934112-3"
})([
    "",
    "{height:750px;}",
    "{height:431px;}"
], responsiveMediaQueries.tabletAndBelow, responsiveMediaQueries.desktopAndAbove);
var RootContainer = styled(Column).withConfig({
    componentId: "sc-6b934112-4"
})([
    "width:100%;"
]);
